// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"a2670287","457":"d67fa66f","787":"c93c8464"}[chunkId] + ".chunk.js";
};